import { Accordion as FASTAccordion } from '@microsoft/fast-foundation';
import { foundationAccordionStyles as styles } from './accordion.styles';
import { foundationAccordionTemplate as template } from './accordion.template';
/**
 * @tagname %%prefix%%-accordion
 */
export class Accordion extends FASTAccordion {
}
export const foundationAccordionShadowOptions = {
    delegatesFocus: true,
    mode: 'open',
};
export const defaultAccordionConfig = {};
/**
 * The Foundation Accordion
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-accordion\>
 */
export const foundationAccordion = Accordion.compose(Object.assign({ baseName: 'accordion', template,
    styles, shadowOptions: foundationAccordionShadowOptions }, defaultAccordionConfig));
